import React from 'react';

const PositionRenderer = ({ rowData: { positions }, columnData: { mappedPositions, hideDeleted = false } = {} }) => {
  const positionsList = positions
    .filter((position) => (hideDeleted ? !mappedPositions?.[position]?.isDeleted : mappedPositions?.[position]))
    .map((position) => mappedPositions?.[position]?.label);

  return <>{positionsList.join(', ')}</>;
};

export default PositionRenderer;
